module.exports = "<div top-nav></div>\r\n<div heading></div>\r\n<div class=\"main-content\" autoscroll=\"true\" ng-cloak ng-view bs-affix-target init-ripples></div>\r\n<div tranding></div>\r\n<div footing></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/html/musichash.html
 ** module id = 44
 ** module chunks = 0
 **/